// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Demander au client de se rediriger",
  "1d484fee4a": "Service financier, Service des ventes, Gestion de projet, Données d'affaires, Département produit, Service des opérations, Gestion de la recherche et développement, Planification de version, Service client, Département administratif, Département des achats, Gestion après-vente",
  "a2c88dfb79": "Créer votre première équipe",
  "3cfdcc6086": "Service financier, Service des ventes, Gestion de projet/305, Administration des ressources humaines/306, Service des opérations, Gestion de la recherche et développement, Planification de version, Gestion du service client/403, Département des achats, Gestion après-vente",
  "ac45ec2c05": "Échec de la vérification du compte",
  "9aef9b8ccd": "Le compte connecté est anormal, veuillez vous reconnecter au compte puis réessayer",
  "728dd00f22": "Anomalie de vérification de ce numéro de téléphone, veuillez essayer de vous connecter avec le code de vérification par SMS",
  "30dbecd916": "Les informations que vous avez saisies contiennent des mots sensibles, veuillez modifier puis réessayer",
  "12ed508d8a": "Vous avez effectué des actions trop souvent, veuillez réessayer plus tard",
  "952d4a7595": "L'état de connexion actuel du compte est anormal, veuillez vous reconnecter au compte puis réessayer",
  "e64bfdeaa4": "Échec de la vérification de connexion, veuillez obtenir à nouveau le code de vérification par SMS",
  "79008a65f1": "Ce numéro de téléphone est déjà associé à plusieurs entreprises, veuillez vous connecter à l'entreprise ou changer de numéro de téléphone",
  "bf242eff42": "Le nom de l'entreprise existe déjà",
  "4f0cdb8374": "Veuillez entrer un numéro de téléphone complet, si vous utilisez un numéro étranger, veuillez le remplacer par un numéro chinois (86+)",
  "46e79ffeff": "Anomalie lors de la création de l'entreprise, veuillez contacter le service client officiel pour résoudre le problème",
  "f3e18f0341": "Échec de la validation des paramètres",
  "503fd1718d": "Échec de l'envoi du code de vérification par SMS",
  "24b3129f19": "Envoi de SMS trop fréquent, veuillez essayer plus tard",
  "1cde3e8245": "Code de vérification incorrect, veuillez le ressaisir",
  "4212ecc031": "Plusieurs erreurs de vérification, vérification temporairement limitée, veuillez essayer plus tard",
  "735da9c347": "Anomalie de vérification du nom de l'entreprise, veuillez contacter le service client officiel pour résoudre le problème",
  "8731da9615": "Anomalie de vérification de l'authentification du nom de l'entreprise, veuillez contacter le service client officiel pour résoudre le problème",
  "62e89b3f16": "Accepter l'accord de service",
  "c9b79027e5": "Envoyer le code de vérification",
  "84c1447b9d": "Copie effectuée avec succès",
  "fba4b0abd0": "Enregistrement principal",
  "37f5a7cd41": "Valeur TXT",
  "78b12427c9": "En cours de vérification...",
  "59d089837c": "Nous ne pouvons actuellement pas vérifier votre domaine, vous devrez peut-être attendre un peu que votre fournisseur d'hébergement de domaine mette à jour vos informations. Si aucune réaction après un certain temps, veuillez essayer de valider à nouveau, ou changer de domaine.",
  "4a5b7383d1": "Vérification du nom de domaine en cours",
  "f24a492e40": "Vous pouvez fermer cette page et revenir plus tard.",
  "c697ca5f1a": "Bienvenue dans la version Entreprise",
  "ebb01b1740": "suivant",
  "30109bf753": "Votre entreprise a-t-elle un nom de domaine ?",
  "2b3e485b47": "J'ai un nom de domaine d'entreprise",
  "1a7f5eae44": "Je n'ai pas de nom de domaine d'entreprise",
  "bde15d6d84": "Vous devez avoir un nom de domaine (par exemple, example.com) pour créer un compte entreprise",
  "07ffb22c90": "Désolé, vous devez avoir un nom de domaine pour créer un compte entreprise pour votre entreprise",
  "de23836563": "Veuillez entrer le nom de domaine pour créer le compte entreprise",
  "287c07944a": "Vérifiez votre nom de domaine",
  "3ea2d528d5": "Suivez ces étapes pour prouver que vous êtes le propriétaire de <b>{domain}</b> et pour empêcher toute autre personne d'utiliser ce domaine pour enregistrer un compte entreprise.",
  "082b18ce56": "a. Ouvrez le site de votre fournisseur d'hébergement de domaine dans un <b>nouvel onglet</b> et <b>connectez-vous</b> à votre compte ;",
  "4f7e0841a9": "b. Dans le site de votre fournisseur d'hébergement de domaine, allez dans la section <b>enregistrements DNS</b>. Sur le site web de votre fournisseur, le nom de cette section peut varier, par exemple être affiché comme <b>Gestion DNS, Gestion du serveur de noms, Panneau de contrôle ou Paramètres avancés.</b>",
  "6365ad6e3a": "Ensuite, <b>revenez ici</b>, puis cliquez sur « Suivant » pour ajouter un enregistrement de validation.",
  "8528892080": "Ajouter l'enregistrement de vérification",
  "7a225304f8": "a. Sur la page DNS, faites défiler jusqu'à la section <b>TXT</b> et cliquez sur le bouton approprié pour ajouter un enregistrement ;",
  "b3cb7d947c": "b. <b>Copiez et collez</b> toutes les valeurs ci-dessous dans le <b>formulaire TXT</b> du site de votre fournisseur d'hébergement de domaine ;",
  "47213583bf": "c. <b>Sauvegarder</b> l'enregistrement sur le site de l'hébergeur de domaines, <br> puis <b>revenez ici</b> et cliquez sur « Certifier le domaine » en bas.",
  "21486a57cf": "Remarque : Dans les champs Nom/Hôte/Alias, vous pouvez entrer « @ » ou laisser vide. Le fournisseur de nom de domaine peut également vous demander d'entrer le nom de domaine dans ce champ (<votre domaine>.com). Vous pouvez éventuellement consulter d'autres enregistrements DNS pour déterminer comment remplir ce champ. Dans le champ Durée de vie (TTL), entrez « 86400 » ou laissez la valeur par défaut.",
  "f1b8edab9c": "Changer de domaine",
  "7c6fc663a8": "Vérifier le domaine",
  "b6aee9dc0d": "Vérification de domaine réussie",
  "dd4cc429ea": "Vous avez prouvé être le",
  "450f5c9230": "propriétaire de ce domaine, empêchant toute autre personne de l'utiliser pour enregistrer un compte entreprise.",
  "71cbcba755": "Cliquez sur « Suivant » pour terminer la création du compte entreprise.",
  "f4084f4870": "Veuillez configurer votre compte de connexion",
  "fe3138baec": "Créer terminé",
  "0315cddedb": "Entreprise créée avec succès",
  "91454a7f34": "Connectez-vous maintenant à l'interface de gestion pour créer des comptes entreprise pour vos membres.",
  "366304cde7": "1. Vous serez automatiquement déconnecté du compte WPS actuel",
  "8a9f2a8422": "2. Vous devez vous connecter à l'espace d'administration avec le compte entreprise {account}@{domain}.",
  "43e265e998": "Se connecter à l'interface de gestion",
  "9240efaaf0": "SMS envoyé",
  "e424bb9a6d": "Entrez",
  "d44d581706": "Nom de l'entreprise",
  "aa8679f406": ", de 4 à 30 caractères",
  "581bdb1f98": "Ne peut pas contenir de symboles spéciaux \\ / : * ? \"<> | {}",
  "c13cabb67a": "e-mail :",
  "2b9b429e46": "Votre email",
  "5ed834a7df": "Veuillez entrer votre email",
  "acfd1f02ed": "Veuillez entrer un email valide",
  "31c7c92cca": ", jusqu'à 80 caractères",
  "3f27cf84b3": "Veuillez entrer le code de vérification",
  "a0ae1f3ec4": "Code de vérification incorrect",
  "e5589c5e74": "Votre nom",
  "69d7bd63f6": ", uniquement caractères chinois, lettres, chiffres",
  "91f008d258": ", jusqu'à 8 caractères",
  "6ea6c9b39b": "Téléphone",
  "161042c5b7": "Veuillez entrer votre numéro de téléphone",
  "e6b8eab1cd": "Veuillez entrer un numéro de téléphone valide de 11 chiffres",
  "3fd5fbb3cc": "Veuillez entrer votre domaine",
  "cb5346ba8e": "Veuillez entrer un domaine d'entreprise valide, de 4 à 30 caractères",
  "27928eb7a4": "Compte",
  "8e19bd444d": "Veuillez entrer un nom de compte pour la connexion",
  "7bbbf479dc": "4-20 caractères, uniquement chiffres, lettres ou underscore",
  "3d84cae479": "Veuillez entrer un compte valide dont le premier caractère doit être une lettre ou un chiffre",
  "c0d5ece1a7": "Mot de passe",
  "f444036fa8": "Entrer le mot de passe",
  "b03218d72b": "Le mot de passe doit être composé de 12 à 16 caractères, comprenant des lettres majuscules et minuscules, chiffres ou une combinaison de trois types",
  "b4ab05df50": "*Quelqu'un dans votre organisation utilise déjà votre domaine pour un compte entreprise. Veuillez contacter le service clientèle (400-677-5005) pour prouver que vous détenez la propriété de ce domaine",
  "c58876008f": "Échec de la copie, veuillez réessayer",
  "86f73420de": "Lien d'invitation",
  "a58861962c": "Désolé, votre navigateur actuel ne prend pas en charge le téléchargement de ce QR code",
  "228db07f78": "Département Finance, Département Vente, Gestion de projet, Données commerciales, Département Produit, Département Opérations, Gestion de la recherche et développement, Plan de version, Département du service client, Département administratif, Département des achats, Gestion après-vente",
  "93896d7e98": "Créez une équipe et commencez à collaborer avec vos collègues",
  "e8f66fb75c": "Service financier, Département des ventes, Gestion de projet/305, Administration du personnel/306, Département des opérations, Gestion de la recherche et développement, Planification des versions, Gestion du service client/403, Département des achats, Gestion après-vente",
  "831b73da9b": "Le nom ne peut pas contenir de caractères illégaux ni de symboles spéciaux/\\;:*?\"<>|%&",
  "51ab33b3ee": "Paramètre incorrect",
  "a297f9e951": "Nom d'entreprise en double",
  "04d60ed5f5": "Ne pas utiliser de mots interdits",
  "2ff7bef083": "Format de domaine incorrect",
  "41e1ba2165": "Échec de la vérification des informations TXT du domaine",
  "50f348caa9": "Compte en double",
  "9d4c950d65": "Ce nom est déjà enregistré",
  "38cf19ed95": "Le nom de l'organisation existe déjà",
  "4b426e7c9c": "Nom de l'organisation",
  "298f880e18": "Déjà existant, nous vous suggérons de fournir plus d'informations :",
  "1e67dd20b3": "Récupérer le nom de l'organisation",
  "517107cb04": "Utiliser un autre nom",
  "5667081882": "Utiliser ce nom pour créer",
  "e306a979a6": "Entrée rapide :",
  "f583db96e0": "*Si le nom de l'organisation est pris, vous pouvez",
  "9767148e34": "Veuillez entrer le nom de l'entreprise ou de l'organisation, 4 à 100 caractères",
  "e0e0ec159f": "Nom de l'organisation",
  "5b13d254c0": "Ce nom d'entreprise existe déjà",
  "92027671ec": "Nom de l'entreprise",
  "36d482a7fb": "Récupérer le nom de l'entreprise",
  "79058a7577": "*Si le nom de l'entreprise est pris, vous pouvez",
  "c96dd48dba": "Nom de l'entreprise",
  "842efad336": "*Si vous êtes un employé de l'entreprise, veuillez",
  "860f9bd77b": "Service client",
  "5a7ed18daf": "Rejoindre l'entreprise",
  "ab470e9ace": "Informations de contact réservées",
  "0a7e0e48a7": "Nom de l'entreprise à laquelle vous souhaitez rejoindre :",
  "a8dc318dcc": "Veuillez vérifier les informations de contact que vous avez fournies, le service client de la plateforme vous appellera bientôt",
  "6ea1f4d7f5": "Soumettre des documents",
  "d439e39f43": "Nous avons reçu vos documents",
  "884653426b": "Le service client vous appellera dans les prochaines 24 heures, veuillez répondre !",
  "2361cb14bf": "Scannez le code WeChat pour ajouter le service client en ligne et suivre l'avancement",
  "50f45d0031": "Échec de l'enregistrement",
  "fc856d0fd2": "Super Administrateur",
  "e16c0676d2": "Administrateurs",
  "b1d2ddd126": "Membre Ordinaire",
  "9d322cc08d": "Le nom de l'organisme ne peut pas contenir de caractères spéciaux \\ / : * ? \" <> | {}",
  "b583ba7363": "Le nom de l'entreprise ne peut pas contenir de caractères spéciaux \\ / : * ? \" <> | {}",
  "1d118a9bad": "Le nom de l'organisation doit comporter au moins 4 caractères, veuillez entrer un nom d'organisation de 4 à 100 caractères",
  "441b45b1f5": "Le nom de l'entreprise doit comporter au moins 4 caractères, veuillez entrer un nom d'entreprise de 4 à 100 caractères",
  "97457cb1f0": "Le nom de l'organisation dépasse 100 caractères, veuillez entrer un nom d'organisation de 4 à 100 caractères",
  "8ce00d3b92": "Le nom de l'entreprise dépasse 100 caractères, veuillez entrer un nom d'entreprise de 4 à 100 caractères",
  "a72778d3de": "Le prénom doit comporter au moins 2 caractères, veuillez entrer un prénom de 2 à 10 caractères",
  "79c17db5de": "Le prénom dépasse 10 caractères, veuillez entrer un prénom de 2 à 10 caractères",
  "482a118202": "Le nom ne prend en charge que les caractères chinois, les chiffres, l'anglais et le point médian ·",
  "9a9be18941": "Veuillez cocher",
  "e6b7c4aa66": "Accord de service en ligne",
  "595023d905": "Créer Institution",
  "ba8c2df551": "Masquer les emplacements courants",
  "d284384975": "Accord De Service En Ligne",
  "5c266d5a84": "Politique de confidentialité",
  "fcb92dbcf6": "Contrat De Service De Bureau En Nuage",
  "2ae7a8a3f7": "Nous Vous Remercions D'avoir Choisi Le Service De Bureau En Nuage WPS 365. Voici Une Introduction Principale De L'accord Légal Entre Vous Et/ Ou L'organisation Que Vous Représentez Et WPS Office Concernant L'enregistrement, L'abonnement Et L'utilisation De Ce Service.",
  "d30a6983bd": "Lisez {0} | {1} | {2}, et en cliquant sur « Accepter », vous acceptez les termes de cet accord et nos services.",
  "263e306ede": "J'ai lu et accepté {0} | {1} | {2}",
  "440129c0f1": "Veuillez Entrer {0}",
  "8ab916983d": "Nom De L'entreprise",
  "b01d68543b": "Votre Nom",
  "684b30d4e9": "Votre Numéro De Téléphone",
  "a48427e8e2": "Utilisé Pour Établir Une Plateforme De Travail Pour Votre Entreprise",
  "3a81b0f1fc": "Facilite La Recherche Par Vos Collègues Dans Le Système Pour La Collaboration De Bureau",
  "52bc539b6e": "Confirmer La Création",
  "b2fe245e19": "Créer Une Entreprise/Équipe: Partage De Fichiers Et Collaboration",
  "893282d3f7": "Veuillez Compléter Les Informations Sur L'entreprise :",
  "cc997bf6aa": "Confirmer",
  "50fdde51ac": "{0}, de {1} à {2} caractères",
  "a19cc5ec18": "{0}, ne peut pas contenir les symboles spéciaux \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, uniquement des caractères chinois, des lettres et des chiffres sont autorisés",
  "f4080b1431": "{0}, au maximum {1} caractères",
  "88e59b2d58": "{0}, 11 chiffres",
  "91d6d4e105": "Veuillez entrer le code de vérification",
  "bec71bde96": "Code de vérification incorrect",
  "e20ff8ee19": "{0} est requis",
  "8dc09d10d7": "dwId introuvable",
  "a03766ce6c": "École",
  "03542addfe": "entreprise",
  "adb8a815d1": "Le numéro de téléphone lié {0} a atteint la limite",
  "97a6b66f1d": "Le numéro de téléphone actuel est déjà lié à {0}",
  "665e465487": "Impossible de créer {0}, le numéro de téléphone actuel « <strong>{1}</strong> » a atteint la limite de {0} liés (maximum 5 {2}). Vous pouvez accéder aux {3} déjà liés ci-dessous :",
  "a85b1367ca": "Le numéro de téléphone actuel « {0} » est déjà lié à {1}, vous pouvez choisir de vous connecter avec l'existant {2} ou créer un nouveau {3} :",
  "bf992ce17b": "Créer {0} avec un autre numéro de téléphone",
  "395ea04444": "Créer un nouveau {0}",
  "4ce3bb86b3": "Limite du nombre de {0} à rejoindre dépassée",
  "df88c4b7a5": "Le numéro de téléphone actuel « {0} » a atteint la limite maximale de liaison {1}",
  "78f7dd59ca": "Le numéro de téléphone actuel « {0} » est lié aux {1} suivants, vous pouvez les utiliser directement",
  "8db491a3f8": "Continuer à créer un nouveau {0}",
  "83f6d9e1e4": "Une autre fois",
  "1dc5f11612": "ou",
  "217d76f53e": "Commentaires",
  "b69a6ea62a": "Veuillez maintenir le bouton gauche de la souris enfoncé pour gratter les deux boucliers",
  "3a31f64800": "Félicitations, vous avez réussi à gratter le bouclier<br/>Continuez à l'étape suivante",
  "6a81fcee96": "Chargement",
  "e97877a65d": "Oh non, le bouclier a disparu<br/>S'il vous plaît",
  "8d85456145": "J'ai attendu trop longtemps<br/>S'il vous plaît",
  "77ad847b95": "La connexion réseau est faible<br/>S'il vous plaît",
  "dbd1ae3a34": "Vous grattez trop vite<br/>S'il vous plaît",
  "bd8e05cd53": "Cliquez sur le bouton pour commencer la vérification intelligente",
  "63d2a8a722": "Vérification réussie",
  "73141928ad": "Échec de la vérification, veuillez cliquer sur le bouton pour actualiser",
  "04856c5c8a": "Détection intelligente en cours",
  "52cd9bd26d": "Votre action n'est pas autorisée",
  "fd157e8ea8": "Créer un guide",
  "c6225c5b2b": "Bienvenue dans la version entreprise",
  "e33423fb1e": "Création réussie",
  "7b0c035999": "Page de succès de la création de l'entreprise de Kingsoft Docs",
  "85db8faae0": "Guide d'utilisation de la version entreprise",
  "20591b9b44": "Récupérer le nom de l'entreprise",
  "b023d76dc2": "Guide de téléchargement des membres",
  "e2f454e095": "Entreprise de {0}",
  "df466f942b": "Division",
  "26a7b797c4": "Centre secondaire",
  "5fc82b360b": "Plateforme de services de bureau tout-en-un pour une efficacité accrue",
  "f2e736d52e": "Bienvenue dans la version entreprise",
  "becc41a35b": "Nom de l'entreprise",
  "74685cdc58": "Veuillez entrer le nom de l'entreprise ou de l'organisation, de 4 à 100 caractères",
  "07b55b1907": "Taille de l'entreprise",
  "77b2f763ad": "Veuillez sélectionner la taille de votre entreprise",
  "49d2509109": "Moins de 5 personnes",
  "8db2c9b74a": "6-20 personnes",
  "a9fb0cf14a": "21-50 personnes",
  "0fed41f8d3": "51-100 personnes",
  "fb33f25a04": "101-200 personnes",
  "3e3ff0f52e": "201-500 personnes",
  "cd8b51f634": "501-2000 personnes",
  "0662fa6eec": "Plus de 2000 personnes",
  "69334dba1a": "Besoins de l'entreprise",
  "79994e749c": "(Nous recommanderons les meilleures pratiques de l'industrie pour l'entreprise)",
  "840a017f38": "Veuillez sélectionner le problème que vous souhaitez le plus résoudre",
  "f045b05c73": "Veuillez saisir le besoin de création de votre entreprise",
  "d8efb0b36d": "Autres",
  "adcb8fbb0c": "Numéro de téléphone courant",
  "eb1c73e2ca": "Veuillez saisir votre numéro de téléphone à 11 chiffres courant",
  "7f276e7dfa": "Créer gratuitement",
  "c391b3eec1": "Échec de l'envoi du SMS",
  "54f4cb8fa7": "SMS envoyé",
  "231eb1fa1e": "Utilisateur entreprise {0}",
  "272b0f9d32": "Utilisateur d'entreprise",
  "b209a67331": "Échec de la création de l'entreprise, veuillez rafraîchir la page.",
  "acb08d0cc9": "Troisième étape de la création d'entreprise",
  "83db361f51": "Après la création, déclencher la logique de redirection",
  "1e930326e3": "handleStep pour passer à l'étape suivante",
  "184df5c725": "Échec de saveForm",
  "736eab3023": "Validation de la soumission",
  "2db62dc13c": "Échec de la validation",
  "54fb0afaea": "Validation réussie",
  "d39cff3fcf": "Passer l'enregistrement extrême pour découvrir que le code de vérification est nécessaire",
  "305b777ae5": "Échec de vérification du nom, ouvrir la fenêtre contextuelle « Nom d'entreprise déjà utilisé » et enregistrer le nom",
  "e57b6686b2": "Vérifiez si l'entité certifiée est déjà certifiée, ouvrez la fenêtre contextuelle de protection de certification et stockez les informations correspondantes au sujet de la certification",
  "f7c86f496d": "Nom de création en double || Code de vérification expiré. Si l'une de ces conditions n'est pas remplie, l'exécution est bloquée",
  "cb37db4fd4": "Échec de la soumission",
  "243a569fc4": "Ce nom est déjà enregistré, veuillez utiliser un autre nom",
  "196851a3d9": "Utilisateur entreprise {0}",
  "0c3a3595ff": "Utilisateur d'entreprise",
  "a33b41e0f2": "Échec de la création de l'entreprise, veuillez rafraîchir la page.",
  "fcce6a7156": "Création réussie",
  "5ec6da58a6": "Notifier le client",
  "259c9dfa4e": "Logique professionnelle",
  "864156930f": "Logique VBA",
  "7824efd172": "Application mobile WPS",
  "52b6cfaaaf": "Client WPS",
  "c7c51beea9": "Version éducative",
  "8d054d4986": "Plateforme par défaut",
  "b597e18fb1": "isWps365PcClient et a openurl",
  "b0c13de2a0": "isWps365PcClient ou non client, a openurl",
  "7d0f2ce18c": "isWps365PcClient ou non-client, avec un callback de succès openurl",
  "e2c5a07df6": "Non client, non openurl",
  "29e0414d1f": "Non client, non openurl callback",
  "60861f7d2a": "Autochangement assigné au service pour basculer",
  "7c83140d90": "Création en mode invité, pas besoin de passer par le SDK pour basculer le compte (SDK ne supporte pas les invités), code a déjà basculé via l'API",
  "3379b09e59": "Avoir openurl et changer avec href",
  "586ff04c22": "Saut individuel",
  "b6c91f218b": "Échec de useSuccessSkip",
  "47d2f3ba66": "Autres",
  "57551f86ce": "Déclenchement des redirections différentes selon la source UTM",
  "64fe3758e2": "Votre action n'est pas autorisée",
  "4da3e1262f": "Création réussie, commencez votre aventure bureautique d'entreprise",
  "c38dfb8c6c": "Créez votre première équipe",
  "38dddb483b": "Accéder à l'entreprise",
  "614d9c91eb": "Inviter des membres à rejoindre",
  "97f1eca0aa": "Accéder à l'entreprise",
  "13a4939e90": "Rejoindre l'invitation de l'entreprise",
  "a319e4ae0a": "Inviter des collègues à rejoindre",
  "12e4da6bba": "Invitez immédiatement des collègues",
  "bd885380f6": "Échec de l'obtention du lien d'invitation",
  "5e626c4063": "SMS envoyé",
  "3dc09e7cfd": "Le nombre de noms d'entreprises récupérés atteint la limite",
  "48318f41f9": "Inviter des membres à rejoindre",
  "45441baac4": "Vous invitez à rejoindre {0} pour collaborer ensemble",
  "e5847fbd67": "Copiez le lien, invitez des membres",
  "23101dd40a": "Nous personnalisons une solution pour vous",
  "71bb7e54a8": "Gestion de projet",
  "aff37c79cc": "Essayez le plan sélectionné",
  "a97b174258": "Invitez à nouveau 2 collègues pour obtenir gratuitement les droits d'entreprise suivants",
  "253855849f": "Partagez le lien d'invitation avec le groupe de travail pour inviter des collègues",
  "57b0a2a63f": "Copiez le lien, invitez des collègues",
  "71c0a37ee1": "Accéder à l'entreprise",
  "f848c60e0e": "Invitez 2 collègues supplémentaires pour obtenir gratuitement les droits d'entreprise suivants",
  "664e32b4fe": "Page d'invitation Accéder à l'entreprise",
  "872f14403a": "Inviter des collègues à rejoindre",
  "1880e7deb9": "Invitez immédiatement des collègues",
  "cc2a9aaf82": "Création réussie",
  "02a13e2583": "Invitez à nouveau 2 collègues pour obtenir gratuitement les droits d'entreprise suivants",
  "5d3593cdce": "Échec de l'obtention des informations de l'équipe",
  "c025113ea1": "Échec de l'obtention du lien d'invitation",
  "b83bc1e485": "Invitation par lien",
  "0996ced9f6": "Désolé, votre navigateur ne prend pas en charge le téléchargement de ce code QR",
  "1e88451e31": "Lien d'invitation copié",
  "bb969cabcd": "Échec de la copie, veuillez réessayer",
  "15e1f79c7a": "Demander à rejoindre l'entreprise",
  "59c22b4ef8": "Reçu un lien d'invitation",
  "0f0b392e60": "Créez votre premier équipe",
  "0437d07c43": "Nom de l'entreprise",
  "41800c7bf1": "Veuillez entrer le nom du créateur",
  "1ec5999511": "Le nom du créateur ne peut pas dépasser 8 caractères",
  "02da35b4e4": "Le nom du créateur ne peut contenir que des caractères chinois, des lettres et des chiffres",
  "184e9f6616": "Veuillez entrer votre numéro de téléphone",
  "9b587898ba": "Veuillez entrer un numéro de téléphone valide",
  "e68c164a02": "Veuillez entrer votre adresse e-mail",
  "0b1de22df7": "Veuillez entrer une adresse e-mail valide",
  "61026181ab": "Licence commerciale obligatoire",
  "c3847e604e": "La taille du fichier dépasse 10 Mo, veuillez choisir à nouveau",
  "49450f4ec7": "Formulaire de réclamation pour noms identiques obligatoire",
  "39c3b8fa1d": "Échec de la soumission",
  "3ea44d7963": "Téléchargement réussi",
  "5b1aa3c2c4": "Échec du téléchargement",
  "7e7f81eaa3": "Échec du téléchargement, le fichier dépasse 10 Mo",
  "2ff1913de1": "Échec du téléchargement, le fichier doit être en .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Licence commerciale obligatoire",
  "66bda65057": "La taille du fichier dépasse 10 Mo, veuillez choisir à nouveau",
  "8f2305a83d": "Formulaire de réclamation pour noms identiques obligatoire",
  "55ff0c8c6e": "Échec de la soumission",
  "8dad6d950d": "Échec de l'obtention des informations d'invitation",
  "a5f0ac3a9a": "Création réussie",
  "4f1d069770": "Le paramètre utm d'accès à la page d'invitation est {0} et le nom {1}",
  "f9578cfe6d": "Le paramètre utm pour l'accès à la double guidage est {0} et le nom {1}",
  "e10d028405": "Deux étapes de guidage pour pcoffice créé",
  "8e22e4fcc4": "Lien d'invitation copié",
  "3f327f9f37": "Échec de la copie, veuillez réessayer",
  "bd1aecb265": "Annuler",
  "b6abf9b19a": "J'accepte",
  "e910d9cc0f": "Annuler",
  "37ab25522d": "J'accepte",
  "196b3eb9cf": "Rejoignez par code QR",
  "2b81c52e20": "Télécharger l'image",
  "62152fd9f3": "Lien d'invitation",
  "e0a3725651": "Désolé, votre navigateur actuel ne prend pas en charge le téléchargement de ce code QR",
  "8b7883b2c7": "Rejoignez par code QR",
  "9e9a659ed5": "Télécharger l'image",
  "0d55065a9a": "Lien d'invitation",
  "487cf6a106": "Désolé, votre navigateur actuel ne prend pas en charge le téléchargement de ce code QR",
  "78fd005d1f": "Veuillez entrer votre numéro de téléphone",
  "f909563857": "Créer avec ce numéro",
  "a26a19f139": "Annuler la création",
  "cc004ac9ee": "Numéro de téléphone",
  "4df8c3c588": "Entrez un autre numéro pour créer une école",
  "3151cabb3d": "Entrez un autre numéro pour créer une entreprise",
  "56098a71eb": "Cliquez sur la vérification intelligente pour envoyer le code de vérification",
  "e96ec218e4": "Veuillez entrer le code SMS",
  "ce619a0225": "Code SMS envoyé à",
  "0e9863aaeb": "Code incorrect, veuillez entrer à nouveau",
  "32dc8629e1": "Renvoyer après quelques secondes",
  "e4eda9add5": "Envoyer de nouveau",
  "b007977564": "Échec de l'obtention des informations d'approbation",
  "d8852ffc9c": "Accès non administrateur",
  "8a733a2574": "Accès mobile",
  "9e8c152c4f": "Accès PC",
  "2265a55e93": "Accepter le contrat de services",
  "80dabe5aa3": "Créer un guide",
  "7deee8bf5a": "Création du guide en deux étapes",
  "69eb501ecb": "Votre réclamation est devenue invalide, vous ne pouvez pas accéder",
  "aa1d9d98ad": "Permissions insuffisantes, accès refusé",
  "fdf2fe129e": "Créer une institution",
  "7f0ca0df6b": "Masquer les emplacements courants",
  "cc6ac2a93c": "Base montée de guidage en deux étapes",
  "5d6c570bf0": "Présentation en deux étapes avant de partir",
  "a4eb8a192d": "Équipe créée par tout le monde",
  "4912e16a9d": "Nom de l'entreprise récupéré",
  "41c4e87ef2": "Vous pouvez cliquer sur le lien",
  "5e630930c0": "Recréer l'entreprise",
  "436a563524": "Si vous avez déjà créé une entreprise, vous pouvez vous référer",
  "0b6e7cbe7f": "Comment modifier le nom de l'entreprise",
  "cb7bce0775": "Tutoriel pour modifier le nom de l'entreprise",
  "3feadd3040": "Version actuelle trop basse, entreprise non utilisable",
  "3cf23de936": "Votre version de logiciel est trop basse, fonctionnalité d'entreprise inutilisable. Veuillez vous rendre sur le marché des applications pour mettre à jour le logiciel !",
  "a1c5d5d202": "OK",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Sécurité, synchronisation, collaboration",
  "c870026dfc": "Connexion WeChat",
  "e7647cd875": "Connexion au compte WPS",
  "07b380074b": "Connexion QQ",
  "67921724dd": "Autres méthodes",
  "254da8a9f5": "Nombre maximal d'entreprises rejointes / créées atteint",
  "3648e4811b": "Entrer dans AirPage",
  "dcd102b346": "Créer une équipe personnalisée",
  "8b9b258cbf": "Entrez le nom de l'équipe ici",
  "19bb6e0ded": "Les membres WPS bénéficient de",
  "2d9fe8d938": "privilèges bureautiques pour résoudre les problèmes de documents dans votre travail quotidien, venez les essayer !",
  "e8c1caa649": "Télécharger depuis le local",
  "03641083a3": "Déplacer depuis 'Documents personnels'",
  "eecd3ab9b5": "La prochaine fois",
  "13b447b3a8": "Remplacer",
  "3c2fc507fc": "Version actuelle trop basse, entreprise non utilisable",
  "c3615d8134": "Votre version de logiciel est trop basse, fonctionnalité d'entreprise inutilisable. Veuillez vous rendre sur le site officiel pour mettre à jour le logiciel !",
  "644a36e05b": "Mettre à jour",
  "d435105f21": "Nombre maximal d'entreprises rejointes / créées atteint",
  "73a286ceb0": "Entrer dans AirPage",
  "c2cec645c0": "Annuler",
  "b5f5b83c0f": "J'accepte",
  "76ec352da5": "Scanner le code pour inviter des collègues",
  "6a509e4487": "Télécharger le code QR",
  "940cc4a546": "Impossible de créer une entreprise",
  "78b2a62ea5": "Entrer dans une entreprise existante ou créer une nouvelle entreprise",
  "3a6da7f6f9": "Le nombre maximal d'entreprises liées à votre numéro de téléphone est atteint (maximum 5 entreprises)",
  "93bab52870": "Votre numéro de téléphone est déjà lié à une entreprise, vous pouvez choisir de vous connecter à une entreprise existante :",
  "ce6e0adaf2": "Vous pouvez choisir d'entrer dans l'entreprise liée en dessous :",
  "1ce200a92b": "Sélectionner",
  "bb91ef2999": "Créer une nouvelle entreprise",
  "024e4a91e5": "Le nom d'entreprise est déjà enregistré",
  "eb089a23a0": "Ce nom d'entreprise est déjà enregistré :",
  "7646558701": "Administrateur :",
  "1d9c02bd33": "Date d'enregistrement :",
  "919fc7805f": "Nous vous suggérons de chercher et de contacter vos collègues ci-dessus.",
  "0ca71a9344": "Vous pouvez également temporairement utiliser un autre nom pour créer une entreprise (modifiable plus tard) et soumettre une réclamation.",
  "e83a244e90": "Cliquez Pour Savoir Comment Faire Appel.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Entrez Un Nom De Groupe De Travail Ou D'équipe",
  "7195b0ac1e": "Équipe Que Vous Souhaitez Peut-Être Créer",
  "60ed4f915e": "suivant",
  "f5ba8dfb7b": "Ignorer L'interface",
  "5c44a3ef68": "Maximum 100 Caractères",
  "130c53fb20": "Le nom ne peut pas contenir de caractères illégaux et de symboles spéciaux/\\;:*?\"<>|%&",
  "e832d41acc": "Deux Étapes Pour L'interface Ignorer",
  "80d9cf7177": "Deux Étapes Pour L'interface Actualiser",
  "0aebf80435": "Deux Étapes Pour L'interface Cliquer Sur Étiquette",
  "e74f515977": "Deux Étapes Pour L'interface Gérer Soumettre",
  "308d2a53c9": "Deux Étapes Pour L'interface Créer Groupe",
  "dda2ed7e18": "Deux Étapes Pour L'interface Échec De Création D'équipe",
  "ded3c35500": "Échec De Création D'équipe",
  "4f18031bc1": "Deux Étapes Pour L'interface Créer Modèle",
  "091e5cefcc": "Deux Étapes Pour L'interface Erreur De Création De Modèle",
  "58cf4e00f0": "Code De Vérification",
  "92abbf0385": "Envoyer Le Code De Vérification",
  "f0f9976ef9": "Veuillez Saisir Votre Numéro De Téléphone",
  "a4ce99b1df": "Code De Vérification",
  "39d36e0f9f": "Confirmer",
  "0fd8a01938": "Envoyer",
  "9048a4e842": "Numéro De Téléphone",
  "9afa1091eb": "Renvoyer",
  "58d787001f": "Saisissez Un Autre Numéro De Téléphone Pour Créer Une École",
  "450905a265": "Saisissez Un Autre Numéro De Téléphone Pour Créer Une Entreprise",
  "f7386de3c6": "Sélectionnez Dans La Liste Déroulante",
  "27aa05a92c": "Accepter L'accord De Service",
  "80af61cb57": "Revenir À La Page Précédente",
  "50149b8d4f": "Nom Du Demandeur",
  "e6756f8749": "Veuillez Saisir Votre Nom",
  "3cbd51a2b1": "Le Nom Doit Compter Au Moins 2 Caractères, Veuillez Saisir Un Nom De 2 À 10 Caractères",
  "4f79b4813f": "Le nom ne prend en charge que les caractères chinois, les chiffres, l'alphabet et le symbole ·",
  "71d3e75983": "Numéro De Téléphone Habituel",
  "afe5149035": "Veuillez Entrer Votre Numéro De Téléphone Habituel",
  "1e9270b50f": "Veuillez Saisir Votre Numéro De Téléphone Habituel, 11 Chiffres",
  "ff5dc98dfb": "Passer",
  "165be2ab43": "Revenir À L'étape Précédente",
  "231d8a335a": "Accepter L'accord De Service",
  "1cad008ffc": "Nom D'entreprise {0} Déjà Enregistré, Veuillez Utiliser Un Autre Nom",
  "c6e274fcab": "Confirmation De L'accord",
  "b9352504bb": "Fermer La Fenêtre Pop-Up De L'accord",
  "8409e99ad0": "Ouvrir La Fenêtre Pop-Up De L'accord",
  "1593c6dd95": "Soumettre",
  "4f44a9de22": "Commencer La Vérification Par SMS",
  "26b70c68b8": "Ignorer Et Accéder Directement À L'entreprise",
  "a8bebcb302": "Revenir À La Page Précédente",
  "c800b4fec5": "Page d'invitation Base montée",
  "38b396d5b0": "Page D'invitation DocsWeb Montée",
  "2eb7f9a9f1": "Votre Appel A Été Soumis Avec Succès",
  "2c6f3590fb": "Nous Prévoyons D'envoyer Les Résultats Du Traitement À Votre E-mail Dans Les 3 Jours Ouvrables",
  "2ea3eff708": ", Veuillez Surveiller Votre Boîte De Réception.",
  "53acfba22c": "Inviter Immédiatement Les Collègues",
  "4e6d282f4f": "Rejoindre L'invitation De L'entreprise",
  "5f72f4b936": "Inviter Immédiatement Les Collègues",
  "e5383077ba": "Récupérer le nom de l'entreprise",
  "06e3fa2350": "Après la recherche,",
  "653a263b5e": "le créateur est",
  "769f57269f": "Le numéro de téléphone du créateur est",
  "09a224695e": "Veuillez confirmer si le créateur de cette entreprise est votre collègue",
  "3beda6c149": "· Si cela est votre collègue, vous pouvez le contacter",
  "5c74dd10d1": "Modifier le nom de l'entreprise ou transférer l'administrateur super.",
  "da504edb0f": "· Si ce n’est pas votre collègue, vous pouvez cliquer sur le bouton ci-dessous pour continuer à récupérer le nom de l’entreprise.",
  "39194faaf1": "Continuer à récupérer le nom de l'entreprise",
  "e22b829e90": "Copie effectuée avec succès",
  "6e1b44752a": "Valeur TXT",
  "79881b1d7a": "Inviter immédiatement des collègues",
  "a5344a45f9": "Cliquez en haut à droite, sélectionnez « Envoyer aux amis »",
  "a4954a5b08": "Inviter immédiatement des collègues",
  "8e3a1625fb": "Récupérer le nom de l'entreprise",
  "bf8b8c7005": "Télécharger le certificat d'enregistrement d'entreprise",
  "bfd44a66c9": "Cliquez pour choisir",
  "d503f20925": "Veuillez télécharger le scan ou la photo du certificat d'enregistrement d'entreprise",
  "cbebe043c5": "Prend en charge les formats JPG, JPEG, PNG, BMP, PDF, taille ne dépassant pas 10 Mo.",
  "9650b96d7d": "Télécharger le formulaire de réclamation pour noms identiques",
  "c3b8ae46d3": "Veuillez télécharger le scan ou la photo du formulaire de réclamation pour noms identiques",
  "9e325a9e09": "Télécharger le modèle de formulaire d'information",
  "a4711aae88": "Soumettre la demande",
  "3a5cc1441e": "En cours de certification...",
  "0bd7bf8511": "Nous ne pouvons actuellement pas vérifier votre domaine, il se peut que vous deviez attendre un moment pour permettre au fournisseur de services d'hébergement de domaine de mettre à jour vos informations. Si après un certain temps, aucune réaction ne se produit, essayez de vérifier à nouveau ou de changer de domaine.",
  "fae48d554b": "Vérification du domaine en cours",
  "5e1779a0ca": "des enregistrements de vérification, vous pouvez fermer cette page et revenir plus tard pour consulter.",
  "ca85f8b836": "Bienvenue dans la version entreprise",
  "2570e0f00b": "Échec de la connexion",
  "40d16a007e": "Votre compte personnel est automatiquement lié",
  "81376b92e4": "Veuillez reconnecter pour changer le compte d'entreprise pour {0}.",
  "ba679ba739": "D'accord, se connecter",
  "c05f64c6c6": "Se connecter après {0}",
  "c329ccef3a": "Échec de la connexion",
  "e370f9afb1": "Votre compte personnel est automatiquement lié",
  "410cf42585": "Veuillez reconnecter avec un autre compte d'entreprise.",
  "062d48aece": "D'accord, se connecter",
  "95a105d412": "Se connecter après",
  "2d000d5a6d": "Envoyer un lien de partage aux membres, les membres peuvent demander à rejoindre après l'avoir ouvert",
  "8861b6e90d": "Entrer dans l'entreprise",
  "25b9f72fda": "Erreur de paramètre de la page",
  "1c76123efc": "Échec de l'obtention du lien d'invitation",
  "6caba48b76": "Passer",
  "f66379c650": "Erreur de paramètre de la page",
  "c45021de2a": "Échec de la création.",
  "011d470126": "La plateforme protège continuellement la sécurité de vos informations",
  "f1a44d9151": "La plateforme a obtenu les certificats ISO27001 et ISO27701 délivrés par l'BSI international, et a réussi l'évaluation de la sécurité de qualification de protection de classe III nationale --",
  "255ea5dff7": "Livre blanc sur la sécurité",
  "bb55b124f2": "Créer une présentation d'entreprise",
  "61e24974a3": "Créer un contenu de stratégie d'acquisition pour l'entreprise",
  "bfdf78febe": "Suivant pour compléter les informations",
  "c4aa2d2d60": "Entrez le nom du groupe de travail ou du projet",
  "b69765ab64": "Équipes couramment créées par tous",
  "9657d9408b": "Remplacer",
  "e21da8c16a": "suivant",
  "224ef5cc9f": "Ignorer l'assistant",
  "641f58c8f6": "L'entreprise actuelle ne prend pas en charge la création d'équipes par les membres, veuillez demander à l'administrateur de créer une équipe",
  "efea622752": "Copier le lien, inviter des collègues",
  "fd5b40a9fd": "Vous inviter à rejoindre « {0} » pour collaborer ensemble",
  "b04dd2f10a": "Lien d'invitation copié",
  "d1606a1b1a": "Échec de la copie, veuillez réessayer",
  "0d59f3db83": "Entrez le département ou l'équipe de projet, tel que « Département des ventes »",
  "9429513d34": "Pas besoin de guide",
  "b54a20b1ff": "Échec de la création.",
  "093fa0fb74": "Autorisation de connexion en cours...",
  "b383b136f4": "Initialisation du projet d'entreprise",
  "b6b21b388b": "Le nom de l'entreprise est déjà enregistré",
  "285dc68c10": "Ce nom d'entreprise est déjà enregistré :",
  "1bf685b89d": "Administrateur :",
  "7b4297edcc": "Date d'enregistrement :",
  "fa51ea19fc": "Nous vous suggérons d'essayer de trouver et de contacter vos collègues mentionnés ci-dessus.",
  "e3678a996d": "Vous pouvez également utiliser temporairement un autre nom pour créer l'entreprise (modifiable ultérieurement), puis soumettre un appel.",
  "5969bc8071": "D'accord",
  "ba4cf699df": "Récupérer le nom de l'entreprise",
  "afecee4eb4": "Votre nom",
  "a8bdebc614": "Veuillez entrer votre nom",
  "5bbeb38a66": "Téléphone",
  "b4f7b44b7a": "Veuillez entrer votre numéro de téléphone",
  "cac2913686": "Adresse e-mail de contact",
  "23d3bb3a42": "Veuillez entrer votre adresse e-mail de contact",
  "ea106a393c": "Télécharger le certificat d'enregistrement de l'entreprise",
  "f74131d71e": "Cliquez pour sélectionner",
  "53749c51c5": "Veuillez télécharger une copie numérisée ou photo du certificat d'enregistrement de l'entreprise",
  "c00f2ea171": "Formats pris en charge : JPG, JPEG, PNG, BMP, PDF, taille maximum de 10 Mo.",
  "57ec07fa97": "Télécharger le formulaire de réclamation pour duplication de nom",
  "8eb0606e94": "Veuillez télécharger une copie numérisée ou photo du formulaire de réclamation pour duplication de nom",
  "f59e76c0b0": "Télécharger le modèle de formulaire d'information",
  "030bd26fa4": "Soumettre la demande",
  "0a602dc727": "Stockage sécurisé des données",
  "9138f28acf": "Partage de fichiers collaboratif",
  "b3a306cf90": "Conformité légale",
  "973c53f725": "Il est conseillé de modifier le nom, une fois enregistré, vous pourrez soumettre une certification d'organisme et mettre à jour le nom",
  "f886f5e92f": "Il est conseillé de modifier le nom, une fois enregistré, vous pourrez soumettre une certification d'entreprise et mettre à jour le nom",
  "b8051702a3": "Ce nom contient des mots sensibles, veuillez ajuster le nom ou contacter le service client",
  "d73881f7d4": "Nom de l'entreprise protégé",
  "dc7e58e320": "Nom de l'entreprise protégé, la vérification des informations de l'entité est nécessaire avant utilisation. Il est conseillé de modifier le nom de l'entreprise, ou de l'utiliser après enregistrement et certification d'entreprise.",
  "20c3bc070c": "Confirmer",
  "c4278e5f28": "Autorisation insuffisante",
  "9217efae21": "Votre compte actuel n'a pas l'autorisation de créer, veuillez contacter un représentant commercial pour assistance",
  "52ff08f2ad": "Nom de l'organisation protégé, veuillez ajuster le nom de l'entreprise",
  "79386ae280": "Veuillez entrer un code de vérification à 6 chiffres",
  "d7b2c5a41b": "Le code de vérification a été envoyé à",
  "ce2e1c26f7": "(Valide pendant 10 minutes)",
  "59d338903f": "Le code de vérification peut être récupéré à nouveau dans {0} secondes",
  "5aadd14136": "Réobtenir le code de vérification",
  "90f5c93432": "Ce nom est déjà enregistré",
  "1677072f4a": "Vous pouvez ajouter plus d'informations ou enregistrer avec un autre nom",
  "3b8459fb1e": "Remplissage rapide :",
  "6f38edbcb1": "Utiliser ce nom pour s'inscrire",
  "8406c81e2d": "Filiale",
  "29d323fa85": "Sous-centre",
  "4f0e806e02": "Département financier",
  "3f935efb6b": "Accepter les conditions de service",
  "b42241be05": "Pas maintenant",
  "99de4b33b7": "J'accepte",
  "7f867e7395": "Créer une entreprise avec un autre numéro de téléphone",
  "0d51a8f7a6": "Continuer à créer",
  "8bdaecf2e5": "Veuillez entrer votre numéro de téléphone",
  "565ae60c8a": "Veuillez entrer votre nom",
  "f76e06d0e7": "Veuillez entrer votre numéro de téléphone",
  "7b0fca5255": "Veuillez entrer le code de vérification",
  "68026d2d25": "Bienvenue dans la version entreprise",
  "d25b5541be": "Créer gratuitement",
  "32cfd73733": "Veuillez entrer le nom de l'équipe, de l'entreprise ou de l'organisation",
  "4cf83dc4a0": "Création rapide en une minute, collaboration efficace avec les collègues",
  "d320d37116": "Créez gratuitement une équipe/entreprise",
  "c54b475dd2": "Conditions d'utilisation",
  "190d54e616": "L'entreprise de {0}",
  "8c1b768ac4": "Échec de la vérification intelligente",
  "d74eab0f35": "Les informations de nom de votre entreprise ne respectent pas les normes de la plateforme, veuillez les modifier puis réessayer",
  "0f3d62dd4f": "Les informations de nom ne respectent pas les normes de la plateforme, veuillez les modifier puis réessayer",
  "647cf2211b": "Ce numéro de téléphone n'est pas pris en charge pour la création, veuillez changer de numéro",
  "b63d96cdae": "Les informations saisies ne respectent pas les normes de la plateforme, veuillez les modifier puis réessayer",
  "2dbbe8e43f": "Ce numéro de téléphone n'est pas pris en charge pour la création, veuillez changer de numéro",
  "b18abc5de6": "Numéro de téléphone non associé",
  "f5233dae6f": "Veuillez changer de numéro pour créer",
  "4167c8b88d": "Le numéro de téléphone actuel peut avoir les incidents suivants, veuillez essayer de changer de numéro pour créer. En cas de questions, veuillez contacter le service client.",
  "a8a2433c4d": "Ajoutez via le scan WeChat, contactez le service client",
  "444a639c09": "Je vois",
  "69a097057f": "Le numéro de téléphone actuel appartient à un opérateur virtuel.",
  "4370b06fd0": "Le numéro de téléphone actuel présente un comportement d'utilisation anormal.",
  "8c49e1dc4a": "Vérification humaine requise",
  "4b8ba7d8cc": "Nouvelle plateforme de productivité pour le bureau",
  "81be771e17": "🎉Entreprise créée avec succès ! Complétez les informations pour obtenir des services exclusifs",
  "461125b057": "Gérez les documents et les ressources au sein de l'équipe. Les membres de l'équipe peuvent facilement voir, et les autorisations d'édition/téléchargement peuvent être définies pour garantir la sécurité des données.",
  "c3eb25029b": "Taille de l'entreprise/équipe",
  "049f8401ec": "Moins de 5 personnes",
  "c81896349e": "6-20 personnes",
  "7357daac4e": "21-50 personnes",
  "f0e65a0a29": "51-100 personnes",
  "b9fac8204a": "101-200 personnes",
  "62d73dddaf": "201-500 personnes",
  "3bcdaf7160": "501-2000 personnes",
  "ab0b2333fe": "Plus de 2000 personnes",
  "4f756eedc8": "Votre rôle est",
  "3ba0b502c3": "Directeur général",
  "702099cc72": "Financier",
  "843b603162": "Achats",
  "8b414a9b44": "Ressources humaines/Administration",
  "92486b2908": "Ventes",
  "ac4e7fb063": "Votre organisation a-t-elle un budget/plan d'achat pour les logiciels de bureau ?",
  "37634c72dc": "Dans les 6 mois",
  "bd94b6deec": "Dans un an",
  "713f4aad5c": "En considération",
  "c5ea095a4d": "Pas de plan pour l'instant",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Créez une équipe et invitez des membres à collaborer ensemble",
  "9d27dc2d90": "Vous pouvez saisir le nom de votre équipe ou le projet récemment suivi",
  "de19c8509a": "Vous devrez peut-être créer :",
  "1a84699223": "Département des ventes",
  "efab59502b": "Département des produits",
  "7e599b3713": "Département d'exploitation Sud",
  "bf494779c2": "Département des achats",
  "f3a60ab34d": "Département administratif",
  "bbc50c1ac8": "Département financier Nord",
  "32629e3dac": "Département financier des produits",
  "5524d354ba": "Département informatique",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Vous avez débloqué les privilèges pour débutant !</span> Invite encore 3 personnes pour obtenir <span style='color: rgb(206,131,62);'>4T d'espace et WPS AI</span> privilèges",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Vous avez débloqué la limite de 50 personnes et 4G pour la taille maximale de fichier téléversé</span>. Continuez d'inviter 3 personnes pour débloquer 30 jours de WPS AI et 4T d'espace avec des privilèges exceptionnels",
  "136c26d941": "Copiez le lien ci-dessous pour inviter des membres",
  "3de5c12558": "Copiez le lien pour inviter des collègues",
  "a5d64b14f3": "Guide d'informations sur l'entreprise",
  "b8f2492701": "Collecte d'informations sur l'entreprise",
  "1f9d053dc0": "Créer un modèle d'équipe",
  "0e83c79a88": "Inviter des membres",
  "821fc1906a": "Entrer dans l'entreprise",
  "463e14ae9c": "Veuillez choisir une équipe",
  "690f0cdb9e": "Icône terminée",
  "c340522a17": "Précédent",
  "f9355c72ef": "Passer",
  "bd6c09ebbb": "suivant",
  "2a2603cd3f": "Envoyer une invitation par QR code à des collègues",
  "411e64907a": "Copier",
  "b0d988cf23": "Télécharger",
  "e3c0b650ac": "Copie effectuée avec succès",
  "713ac624b4": "Bienvenue dans WPS 365",
  "b8fff97849": "Élément cible invalide",
  "02acdcf296": "Échec de la conversion html2canvas, canvas non généré",
  "a76988c496": "Échec de la conversion de canvas en blob",
  "af89584edf": "API du presse-papiers non disponible",
  "f90263bbde": "Échec de copie d'image",
  "71b05319da": "Échec de la conversion html en canvas",
  "38852999fe": "Échec de l'enregistrement des informations",
  "4a4c621d07": "Échec de la création de l'équipe, veuillez réessayer plus tard",
  "d239a23994": "La page actuelle est réservée aux comptes d'entreprise, veuillez vous connecter avec un compte d'entreprise.",
  "d93bfb7fb9": "Entrez votre contenu",
  "42b81a66c4": "Longueur de 2 à 100 caractères",
  "76d33733db": "Ne peut pas contenir / \\ ; : * ? \" < > | % & et autres caractères spéciaux",
  "dc55d1f62f": "Essayez Maintenant",
  "b25233cba0": "Collaboration de documents + messagerie instantanée, pour une nouvelle façon de travailler efficacement",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Démarrez une discussion de groupe collaborative, partage de documents sécurisé et pratique",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Assistant AI Lingxi, un assistant intelligent créé pour le bureau",
  "e338385bc9": "Agent Intelligent De Bureau Office Intégré, Fusion Approfondie De L'IA Et Des Logiciels De Bureau Pour Permettre À Chaque Personne D'Avoir Un Assistant IA",
  "7ae1f3b1c6": "Importation De Fichier (Dossier) Terminée, Vous Pouvez Voir Les Résultats De L'Importation Dans « Mes Docs Cloud »",
  "85db2a024a": "Anomalie D'Importation De Fichier (Dossier), Veuillez Réessayer Plus Tard",
  "9ff74c802a": "Télécharger La Version Pour Chipset Intel",
  "ab44928f02": "Télécharger La Version Pour Chipset Apple",
  "a08d937c38": "Téléchargement De Fichier (Dossier) En Cours, Vous Pouvez Voir Dans « Mes Docs Cloud » Après Achèvement",
  "68db1829fa": "Importation Depuis Le Compte Personnel Uniquement, Veuillez Vous Connecter À Votre Compte Personnel Et Réessayer.",
  "1185a7c7ab": "Moins De 20 Personnes",
  "e2bcc252c9": "21-300 Personnes",
  "3c4842f1ea": "301-1000 Personnes",
  "1bbee64cfa": "Plus De 1000 Personnes",
  "388ff4a035": "Enseignant",
  "d341b1d794": "Étudiant",
  "bfb2ee4148": "Autres",
  "f6450c3f31": "Gestion De Projet",
  "b87fd33a0d": "Plan Annuel",
  "0dd45a1c14": "Gestion Des Performances Du Personnel",
  "67fa01cac6": "Activités De Marketing",
  "6dd82cc031": "Recrutement Du Personnel",
  "a7edaed91d": "Documents Pédagogiques",
  "bf12b7efb0": "Gestion Du Plan D'Enseignement",
  "c35ae8f358": "Document De Produit",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Tableau Multi-Dimensionnel, Construction Visuelle De Systèmes D'Affaires Autonomes",
  "72286d5519": "👏Modèles Recommandés",
  "0bc00ee949": "Gestion Des Défaillances Des Besoins",
  "e22f3d56f7": "Gestion De La Création De Contenu",
  "dd439de3dd": "Système De Gestion De La Clientèle",
  "fbb2bbf82e": "Planification Des Examens",
  "0645b908bc": "Consultation Des Tables De Salaire",
  "813b3d3d7e": "Gestion des OKR",
  "918e33d5bd": "Créer En Un Clic",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importez Des Documents courants, Utilisation Plus Pratique",
  "c58f28713c": "Importer Localement",
  "9d6a0a4370": "Prise en charge des formats de fichiers courants d'Office",
  "54c48aee85": "Sélectionner un fichier",
  "c5b593e452": "Importer Depuis Compte Personnel",
  "4bdcd9d4c5": "Importer En Un Clic Les Documents, Équipes, Dossiers De Compte Personnel",
  "99b2968905": "Autoriser l'importation",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Télécharger le client WPS Teams",
  "fe46574227": "Collaboration de documents + messagerie instantanée, une nouvelle méthode de travail efficace",
  "beefe5a09b": "Télécharger maintenant télécharger",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Paramètres de sécurité riches, garantissent la sécurité des données",
  "b4e70dbeab": "Expérience en sécurité des documents WPS accumulée depuis des années, garantir que les données critiques de l'entreprise ne sont pas divulguées",
  "42dc772619": "Le fichier est trop grand, il est conseillé d'importer à nouveau depuis la page d'accueil plus tard",
  "a052564e47": "Erreur de création, veuillez réessayer plus tard"
}